
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/business-customers",
      function () {
        return require("private-next-pages/[locale]/help/business-customers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/business-customers"])
      });
    }
  